// src/components/ResizeObserverErrorHandler.js
import { useEffect } from 'react';

function ResizeObserverErrorHandler() {
  useEffect(() => {
    // First approach: Handle through error event
    const errorHandler = (event) => {
      if (
        event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        event.message?.includes('ResizeObserver loop') ||
        event.error?.message?.includes('ResizeObserver loop')
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
        console.log('ResizeObserver error suppressed');
      }
    };

    // Second approach: Patch the ResizeObserver prototype
    const originalResizeObserver = window.ResizeObserver;
    if (originalResizeObserver) {
      window.ResizeObserver = class PatchedResizeObserver extends originalResizeObserver {
        constructor(callback) {
          super((entries, observer) => {
            // Wrap the callback in a try-catch to prevent errors from bubbling up
            try {
              callback(entries, observer);
            } catch (e) {
              if (e.message.includes('ResizeObserver loop')) {
                console.log('ResizeObserver error caught and suppressed');
              } else {
                throw e;
              }
            }
          });
        }
      };
    }

    window.addEventListener('error', errorHandler);
    window.addEventListener('unhandledrejection', errorHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
      window.removeEventListener('unhandledrejection', errorHandler);
      // Restore original ResizeObserver
      if (originalResizeObserver) {
        window.ResizeObserver = originalResizeObserver;
      }
    };
  }, []);

  return null;
}

export default ResizeObserverErrorHandler;
